import React, { useEffect, useState } from 'react';
import { SplitView } from './SplitView';
import { GridView } from './GridView';
import { TableView } from './TableView';
import { useFilteredProperties } from '../queries/useFilteredProperties';
import PublicMap from '../../../public-map/presentation/components/PublicMap';
import { HeaderPublicViewer } from './HeaderPublicViewer';
import { fetchFavoritesThunk } from '../../../../redux/state/favoriteSlice';
import { fetchLspjs } from '../../../../redux/state/lspjSlice';
import { fetchColumns } from '../../../../redux/state/columnsSlice';

import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../redux/store';
import { setMapKey } from '../../../../redux/state/mapSlice';
import List from '../../../../components/property-list-viewer/PropertyList';

export type ViewMode = 'split' | 'list' | 'grid' | 'table' | 'map';

export const PublicViewer = ({
  mapKey,
  listSortId,
}: {
  mapKey: string;
  listSortId: string;
}) => {
  const [view, setView] = useState<ViewMode>('split');
  const { properties, isLoading, error } = useFilteredProperties();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // run initial fetch favorites to populate redux store
    dispatch(fetchFavoritesThunk());
    dispatch(fetchLspjs(listSortId));
    dispatch(fetchColumns());
    dispatch(setMapKey(mapKey));
  }, []);

  return (
    <div className="h-[calc(100vh-64px)] min-h-0 w-full flex flex-col bg-neutral-100 overflow-hidden pb-4">
      <HeaderPublicViewer view={view} setView={setView} />

      {view === 'split' && (
        <SplitView
          mapKey={mapKey}
          properties={properties}
          isLoading={isLoading}
          error={error}
        />
      )}
      {view === 'list' && <List listSortId={listSortId} />}
      {view === 'grid' && (
        <GridView properties={properties} isLoading={isLoading} error={error} />
      )}
      {view === 'table' && (
        <TableView
          mapKey={mapKey}
          properties={properties}
          isLoading={isLoading}
          error={error}
        />
      )}
      {view === 'map' && <PublicMap mapKey={mapKey} />}
    </div>
  );
};
